var d = {
   pdf: { mimeName: 'Adobe Portable Document Format', mimeType: 'application/pdf', extension: '.pdf', type: 'pdf' },
   doc: { mimeName: 'Microsoft Word', mimeType: 'application/msword', extension: '.doc', type: 'doc' },
   docx: {
      mimeName: 'Microsoft Word (OOXML)',
      mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      extension: '.docx',
      type: 'docx'
   },
   xls: { mimeName: 'Microsoft Excel', mimeType: 'application/vnd.ms-excel', extension: '.xls', type: 'xls' },
   xlsx: {
      mimeName: 'Microsoft Excel (OOXML)',
      mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      extension: '.xlsx',
      type: 'xlsx'
   },
   ppt: { mimeName: 'Microsoft PowerPoint', mimeType: 'application/vnd.ms-powerpoint', extension: '.ppt', type: 'ppt' },
   pptx: {
      mimeName: 'Microsoft PowerPoint (OOXML)',
      mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      extension: '.pptx',
      type: 'pptx'
   },
   odt: { mimeName: 'OpenDocument Text', mimeType: 'application/vnd.oasis.opendocument.text', extension: '.odt', type: 'odt' },
   ods: {
      mimeName: 'OpenDocument Spreadsheet',
      mimeType: 'application/vnd.oasis.opendocument.spreadsheet',
      extension: '.ods',
      type: 'ods'
   },
   rtf: { mimeName: 'Rich Text Format', mimeType: 'application/rtf', extension: '.rtf', type: 'rtf' },
   csv: { mimeName: 'Comma-Separated Values', mimeType: 'text/csv', extension: '.csv', type: 'csv' },
   tsv: { mimeName: 'Tab-Separated Values', mimeType: 'text/tab-separated-values', extension: '.tsv', type: 'tsv' },
   epub: { mimeName: 'eBook (EPUB)', mimeType: 'application/epub+zip', extension: '.epub', type: 'epub' },

   png: { mimeName: 'Portable Network Graphics', mimeType: 'image/png', extension: '.png', type: 'png' },
   jpg: { mimeName: 'JPEG Image', mimeType: 'image/jpeg', extension: '.jpg', type: 'jpg' },
   gif: { mimeName: 'Graphics Interchange Format', mimeType: 'image/gif', extension: '.gif', type: 'gif' },
   webp: { mimeName: 'WebP Image', mimeType: 'image/webp', extension: '.webp', type: 'webp' },
   svg: { mimeName: 'Scalable Vector Graphics', mimeType: 'image/svg+xml', extension: '.svg', type: 'svg' },
   bmp: { mimeName: 'Bitmap Image', mimeType: 'image/bmp', extension: '.bmp', type: 'bmp' },
   ico: { mimeName: 'Icon File', mimeType: 'image/vnd.microsoft.icon', extension: '.ico', type: 'ico' },

   mp3: { mimeName: 'MPEG Audio', mimeType: 'audio/mpeg', extension: '.mp3', type: 'mp3' },
   flac: { mimeName: 'FLAC Audio', mimeType: 'audio/flac', extension: '.flac', type: 'flac' },
   wav: { mimeName: 'WAV Audio', mimeType: 'audio/wav', extension: '.wav', type: 'wav' },
   ogg: { mimeName: 'Ogg Audio', mimeType: 'audio/ogg', extension: '.ogg', type: 'ogg' },
   m4a: { mimeName: 'MPEG-4 Audio', mimeType: 'audio/mp4', extension: '.m4a', type: 'm4a' },
   aac: { mimeName: 'Advanced Audio Coding', mimeType: 'audio/aac', extension: '.aac', type: 'aac' },
   aiff: { mimeName: 'Audio Interchange File Format', mimeType: 'audio/aiff', extension: '.aiff', type: 'aiff' },

   mp4: { mimeName: 'MPEG-4 Video', mimeType: 'video/mp4', extension: '.mp4', type: 'mp4' },
   mpeg: { mimeName: 'MPEG Video', mimeType: 'video/mpeg', extension: '.mpeg', type: 'mpeg' },
   mov: { mimeName: 'QuickTime Video', mimeType: 'video/quicktime', extension: '.mov', type: 'mov' },
   avi: { mimeName: 'AVI Video', mimeType: 'video/x-msvideo', extension: '.avi', type: 'avi' },
   mkv: { mimeName: 'Matroska Video', mimeType: 'video/x-matroska', extension: '.mkv', type: 'mkv' },
   webm: { mimeName: 'WebM Video', mimeType: 'video/webm', extension: '.webm', type: 'webm' },
   '3gp': { mimeName: '3GPP Multimedia File', mimeType: 'video/3gpp', extension: '.3gp', type: '3gp' },
   m4v: { mimeName: 'MPEG-4 Video', mimeType: 'video/x-m4v', extension: '.m4v', type: 'm4v' },

   zip: { mimeName: 'ZIP Archive', mimeType: 'application/zip', extension: '.zip', type: 'zip' },
   rar: { mimeName: 'RAR Archive', mimeType: 'application/vnd.rar', extension: '.rar', type: 'rar' },
   '7z': { mimeName: '7-Zip Archive', mimeType: 'application/x-7z-compressed', extension: '.7z', type: '7z' },
   tar: { mimeName: 'TAR Archive', mimeType: 'application/x-tar', extension: '.tar', type: 'tar' },
   gz: { mimeName: 'Gzip Archive', mimeType: 'application/gzip', extension: '.gz', type: 'gz' },

   html: { mimeName: 'HTML Document', mimeType: 'text/html', extension: '.html', type: 'html' },
   css: { mimeName: 'CSS Stylesheet', mimeType: 'text/css', extension: '.css', type: 'css' },
   js: { mimeName: 'JavaScript File', mimeType: 'application/javascript', extension: '.js', type: 'js' },
   json: { mimeName: 'JSON Data', mimeType: 'application/json', extension: '.json', type: 'json' },
   xml: { mimeName: 'XML Document', mimeType: 'application/xml', extension: '.xml', type: 'xml' },
   md: { mimeName: 'Markdown Text', mimeType: 'text/markdown', extension: '.md', type: 'md' },

   ttf: { mimeName: 'TrueType Font', mimeType: 'font/ttf', extension: '.ttf', type: 'ttf' },
   otf: { mimeName: 'OpenType Font', mimeType: 'font/otf', extension: '.otf', type: 'otf' },
   woff: { mimeName: 'Web Open Font Format', mimeType: 'font/woff', extension: '.woff', type: 'woff' },
   woff2: { mimeName: 'Web Open Font Format 2', mimeType: 'font/woff2', extension: '.woff2', type: 'woff2' },

   exe: { mimeName: 'Windows Executable', mimeType: 'application/vnd.microsoft.portable-executable', extension: '.exe', type: 'exe' },
   apk: { mimeName: 'Android Package', mimeType: 'application/vnd.android.package-archive', extension: '.apk', type: 'apk' },
   ics: { mimeName: 'iCalendar File', mimeType: 'text/calendar', extension: '.ics', type: 'ics' }
};

// Build lookup dynamically for both MIME types and extensions
var lookup = {};
Object.keys(d).forEach((key) => {
   lookup[key] = d[key];
   lookup[d[key].mimeType] = d[key];
});

//////////////

function map(key) {
   key = key.toLowerCase();

   var k = lookup[key];
   if (!k) {
      if (key.includes('/')) {
         k = { mimeName: 'Unknown', mimeType: key, extension: '.unknown', type: 'url' };
      } else {
         k = { mimeName: 'Unknown', mimeType: 'unknown', extension: '.' + key, type: key };
      }
   }
   return k;
}

//////////////

module.exports = {
   map: map
};
